export const detailRoutes = {
    "/documents": {
        title: "Documents",
    },
    "/conversation": {
        title: "conversations"
    },
    "/financeinformation": {
        title: "Finance Information"
    }
};
